type IconStarProps = {
    fill?: string;
};

export const IconStar = ({ fill = 'none' }: IconStarProps) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9 1L11.9666 5.55133L17 7.11146L13.8 11.4845L13.9443 17L9 15.1513L4.05573 17L4.2 11.4845L1 7.11146L6.03344 5.55133L9 1Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
